import { QuoteRequestForm } from './quote-request-form.js';

// Create a new quote request form if we have a `js-quote-request` element.
const quoteRequestRoot = document.getElementById('js-quote-request');
if (quoteRequestRoot) {
	const QuoteRequest = new QuoteRequestForm(quoteRequestRoot, {
		nextStepsUrl: GS.nextStepsUrl,
		initiateOtpUrl: GS.initiateOtpUrl,
		validateOtpUrl: GS.validateOtpUrl
	});
}

export default QuoteRequestForm;
